import { Box, Paper, Stack, TextField, Typography } from '@mui/material';
import { t } from 'i18next';
import { ChangeEventHandler, useRef } from 'react';
import { and } from '../../../../common/hooks/use-form-item/validators/compositions';
import { required } from '../../../../common/hooks/use-form-item/validators/existential';
import { greaterOrEqualThan, lessThan } from '../../../../common/hooks/use-form-item/validators/operational';
import { number } from '../../../../common/hooks/use-form-item/validators/type';
import { TracerStore } from '../../store/TracerStore';
import { MAX_INPUT, MIN_INPUT } from '../../utils/constants';

export const ExpiringSoonDisplay = () => {
  const store = useRef(TracerStore.getInstance()).current;
  const value = store.getExpiringSoon();

  const validateExpiringSoonNumber = and(required(), number(), greaterOrEqualThan(MIN_INPUT), lessThan(MAX_INPUT));

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const n = Number(e.target.value);
    if (validateExpiringSoonNumber(n) !== true) {
      return;
    }
    store.setExpiringSoon(n);
  };

  return (
    <Stack direction={{ xs: 'column', lg: 'row' }} gap={4} sx={{ p: 2, backgroundColor: 'grey.100' }}>
      <Typography id="expiring-soon-label" sx={{ flex: 4 }} variant="body2">
        {t('createProfile.expiringCertificateDescription')}
      </Typography>
      <Box sx={{ width: 1, flex: 6 }}>
        <Paper sx={{ p: 2 }}>
          <Typography aria-hidden={!store.isEditable()} sx={{ mb: 2 }}>
            {t('createProfile.expiringSoon.title')}
          </Typography>
          <TextField
            className="tracer-input-field"
            type="text"
            label={t('createProfile.expiringSoon.label')}
            variant="standard"
            value={value}
            disabled={!store.isEditable()}
            error={value <= 0}
            helperText={value <= 0 ? t('validators.operational.compare.gt', { value: 0 }) : ''}
            onChange={handleChange}
            inputProps={{ min: 1, step: 1, 'aria-labelledby': 'expiring-soon-label', pattern: '[1-9][0-9]*' }}
          />
        </Paper>
      </Box>
    </Stack>
  );
};
